// src/components/SuperAdmin/Dashboard.js
import React, { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Layers, Tag } from 'lucide-react';

export default function Dashboard() {
    const navigate = useNavigate();

    // Quick action cards that map to your routes
    const actions = useMemo(
        () => [
            {
                id: 'blog',
                to: '/blog-dashboard',
                label: 'Blog Dashboard',
                desc: 'Create, edit and manage blog posts',
                icon: FileText,
                color: 'bg-indigo-600',
            },
            {
                id: 'case-studies',
                to: '/case-studies-dashboard',
                label: 'Case Studies',
                desc: 'Review & publish case studies',
                icon: Layers,
                color: 'bg-emerald-600',
            },
            {
                id: 'brand',
                to: '/brand-details',
                label: 'Manage Brand',
                desc: 'View and edit brand details & assets',
                icon: Tag,
                color: 'bg-sky-600',
            },
        ],
        []
    );

    const goTo = useCallback(
        (path) => {
            navigate(path);
        },
        [navigate]
    );

    // Placeholder stats — replace with live data or hooks later
    const stats = useMemo(
        () => [
            { id: 'posts', label: 'Published Posts', value: 12 },
            { id: 'studies', label: 'Case Studies', value: 5 },
            { id: 'assets', label: 'Brand Assets', value: 23 },
        ],
        []
    );

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <header className="mb-6">
                <h1 className="text-3xl font-semibold text-gray-900">Super Admin Dashboard</h1>
                <p className="text-sm text-gray-600 mt-1">Overview & quick actions for site management.</p>
            </header>

            {/* Quick action cards */}
            <section aria-labelledby="quick-actions">
                <h2 id="quick-actions" className="text-xl font-medium text-gray-800 mb-4">
                    Quick Actions
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    {actions.map((action) => {
                        const Icon = action.icon;
                        return (
                            <button
                                key={action.id}
                                onClick={() => goTo(action.to)}
                                className={`relative group text-left overflow-hidden rounded-lg p-5 h-32 flex flex-col justify-between shadow hover:shadow-md focus:outline-none focus:ring-2 focus:ring-indigo-300 ${action.color} text-white`}
                                aria-label={action.label}
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <h3 className="text-lg font-semibold">{action.label}</h3>
                                        <p className="mt-1 text-sm opacity-90">{action.desc}</p>
                                    </div>
                                    <div className="opacity-90">
                                        <Icon size={28} />
                                    </div>
                                </div>

                                <span className="text-xs opacity-80">Open</span>
                            </button>
                        );
                    })}
                </div>
            </section>

        </div>
    );
}
